import { ADD_COURSE, addCourseSuccess, addCourseFailed } from "../actions";
import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { from, of } from "rxjs";
import CoursesApi from "../../../services/courses-api";

export default (action$) =>
  action$
    .pipe(ofType(ADD_COURSE))
    .pipe(switchMap(({ payload }) => addMyCourse(payload)));

const addMyCourse = (payload) =>
  from(CoursesApi.postMyCourses(payload.course_id))
    .pipe(
      map((response) =>
        addCourseSuccess(response.data.golfer_course_preference)
      )
    )
    .pipe(catchError((error) => of(addCourseFailed(error))));
